interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type: schemaType, data }: SchemaOrgProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '日韩在线',
      url: 'https://yongtaic.cn',
      logo: 'https://yongtaic.cn/logo.png',
      description: '正版日韩内容一站聚合平台，提供最新日韩影视、音乐、综艺、资讯内容',
      email: 'contact@yongtaic.cn',
      telephone: '+86-400-888-6688',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '望京SOHO T3-A座 2501室',
        addressLocality: '北京',
        addressRegion: '朝阳区',
        addressCountry: 'CN',
      },
      sameAs: [
        'https://weibo.com/rikkanonline',
        'https://space.bilibili.com/rikkanonline',
      ],
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '日韩在线',
      url: 'https://yongtaic.cn',
      description: '正版日韩内容一站聚合平台，提供最新日韩影视、音乐、综艺、资讯内容',
      potentialAction: {
        '@type': 'SearchAction',
        'target': {
          '@type': 'EntryPoint',
          urlTemplate: 'https://yongtaic.cn/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      ...data,
    },
    BreadcrumbList: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = schemas[schemaType];
  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}